import { Component, Input, Output, OnInit, OnChanges, EventEmitter } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-pie-graph',
  templateUrl: './app-pie-graph.component.html',
  styleUrls: ['./app-pie-graph.scss']
})

export class AppPieGraphComponent implements OnChanges {

  @Input() answers: Array<any>;
  @Input() selected: number;
  @Output() clicked: EventEmitter<any> = new EventEmitter<any>();

  private loading = false;
  public doughnutChartLabels: string[] = ['Answer B', 'Answer A'];
  public doughnutChartColour: Array<any> = [
    { // brandInfo
      backgroundColor: ['#0171BC', '#662D91'],
      borderWidth: [0, 0]
    }];
    public doughnutChartOption = {
      cutoutPercentage: '',
      legend: {
        display: false,
        filter: function () { }
      },
      title: {
        display: true,
        fontSize: 20
      },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        },
        margin: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }
      }
    };
    public doughnutChartData: number[] = [];
    public doughnutChartType = 'doughnut';

    constructor(private _changeDetector: ChangeDetectorRef) {}

    ngOnChanges($event) {
      // this._changeDetector.markForCheck();
      // console.log('default', this.selected);
      if (!this.selected) {
        this.selected = -1;
      }
      this.setup();
    }

    setup() {
    // console.log('setup..');

    this.loading = true;
    // setTimeout(() => {
      this.loading = false;
      this.doughnutChartLabels.length = 0;
      this.doughnutChartData.length = 0;
      this.doughnutChartColour.length = 0;

      if (this.answers) {
        // console.log('answers', this.answers);
        this.doughnutChartData.push(this.answers[0]['percentage']);
        this.doughnutChartData.push(this.answers[1]['percentage']);
        this.doughnutChartLabels.push('Answer A');
        this.doughnutChartLabels.push('Answer B');
        this.doughnutChartColour.push(    { // brandInfo
          backgroundColor: ['#0171BC', '#662D91'],
              // borderWidth: [this.selected === 0 ? 2 : 2, this.selected === 1 ? 2 : 2], // Cambia il primo valore per stringere la slice
              borderColor: ['white', 'white']
            });

        this.doughnutChartOption.cutoutPercentage = '70';
        this.doughnutChartOption.title['text'] =
        'Answered ' + (parseInt(this.answers[0]['count'], 10) + parseInt(this.answers[1]['count'], 10)) + ' times';
      }
    // }, 1);
  }


  // events
  public chartClicked(e: any): void {
    if (e['active'] && e['active'][0]) {
      const clicked = e['active'][0]['_index'];
      this.tabClicked(clicked);
    }
  }

  tabClicked(t) {
    const clicked = t;
    this.selected = clicked;
    this.clicked.emit(clicked);
    // console.log('tabClicked', this.selected);
  }

  public chartHovered(e: any): void {
    // console.log(e);
  }

}
